// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require('utils/direct_uploads')
require("@rails/activestorage").start()
require("channels")

import Rails from '@rails/ujs';
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'

import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

import './stylesheets/application.scss'

import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'

import GLightbox from 'glightbox'
import 'glightbox/dist/css/glightbox.min.css'

import { createApp } from 'vue'
import PermissionsApp from './apps/PermissionsApp.vue'
import BulkActionSelector from '@components/BulkActionSelector.vue'
import BulkActionService from '@services/BulkActionService.js'
import StandardizedLocation from '@components/StandardizedLocation'
import InteractiveGoogleMaps from '@components/InteractiveGoogleMaps'
import SearchableSelect from '@components/SearchableSelect.vue'
import siloLocationSelector from '@components/siloLocationSelector.vue'
import StaticKestrelMap from '@components/StaticKestrelMap.vue'
import SurveyBatch from '@components/kestrel/v2/SurveyBatch'

import 'vue-multiselect/dist/vue-multiselect.css'
import 'font-awesome/css/font-awesome.min.css'

import TurbolinksAdapter from 'vue-turbolinks'
import DirectUploadHandler from '@services/DirectUploadHandler'

import "@hotwired/turbo-rails"

import { load_autocomplete } from '@services/AutoCompleteLoader'
import axios from 'axios'

import ModalService from '@services/ModalService'

import { GoogleMap, Marker, InfoWindow, MarkerCluster } from 'vue3-google-map'

import FlashMessages from '@services/FlashMessages'

import TargetAreaKestrel from './apps/experiments/TargetAreaKestrel.vue'
import SurveyBatchKestrel from './apps/experiments/SurveyBatchKestrel.vue'
import OpenModalButton from '@components/general/OpenModalButton.vue'
import TargetArea from '@components/TargetArea.vue'
import TargetAreaKestrelV2 from '@components/kestrel/v2/TargetArea.vue'
import TargetAreas from '@components/kestrel/v2/TargetAreas.vue'
import AchieveDashboardStats from '@components/AchieveDashboardStats.vue'
import FindMissingRelatableButton from '@components/FindMissingRelatableButton.vue'
import MrdValidationSection from '@components/mrd/MrdValidationSection.vue'
import ResourceDeploymentDeploy from '@components/ResourceDeploymentDeploy.vue'

import field_rep_forms from './application_parts/field_rep_forms'
import issues from './application_parts/field_rep_issues'
import tot_expense_reports from './application_parts/tot_expense_reports'

import * as QuickSightEmbedding from 'amazon-quicksight-embedding-sdk'

import GlobalEventBus from '@services/GlobalEventBus'

Rails.start()

document.addEventListener('turbo:load', () => {
  // VUE TODOO: we have to go and allow all vue objects access to Rollbar
  // this has been removed in Vue 3
  // Vue.prototype.$rollbar = window.Rollbar
  // ************************************************************
  // before - Vue 2
  // Vue.prototype.$http = () => {}

  // after - Vue 3
  // const app = createApp({})
  // app.config.globalProperties.$http = () => {}
  // ************************************************************


  // VUE TODOO: we have to go and allow this in ALL vue objects (global find for "import { CreateApp }")
  // this is no longer allowed in Vue 3
  // Vue.config.errorHandler = (err, vm, info) => {
  //   window.Rollbar.error( err, info );
  //   throw err; // rethrow
  // };



  // **************************************************************************************************************************************************
  // In between the moment that the form is submitted and the user is actually redirected the submit button is suddenly enabled again after some time.
  // This can mainly be exploited on slow connections, allowing users to repeatly click the submit button.
  // Since the button is enabled again in Turbo's FormSubmission.requestFinished method just before dispatching a TurboSubmitEndEvent,
  // we can workaround this problem by re-disabling the button again by declaring a listener on turbo:submit-end
  // **************************************************************************************************************************************************
  document.addEventListener('turbo:submit-end', (event) => {
    if (event.detail.fetchResponse && event.detail.fetchResponse.response && event.detail.fetchResponse.response.redirected === true) {
      event.target.querySelectorAll('[type=submit]').forEach((button) => {
        button.disabled = true
      })
    }
  })

  // ************************************************************
  // Resource Donation receipt quantity warning (total exceeds committed)
  // ************************************************************
  const recordReceiptForm = document.getElementById('record-receipt-form')
  if (recordReceiptForm) {
    recordReceiptForm.addEventListener('submit', (e) => {
      const qtyInput = document.getElementById('receipt-quantity-input')
      const wrapper = document.getElementById('receipt-form-wrapper')
      if (qtyInput && wrapper) {
        const newQty = parseInt(qtyInput.value || 0, 10)
        const committed = parseInt(wrapper.dataset.committedQuantity || 0, 10)
        const alreadyDelivered = parseInt(wrapper.dataset.alreadyDelivered || 0, 10)
        const totalWouldBe = alreadyDelivered + newQty
        if (committed > 0 && totalWouldBe > committed && !confirm('Total quantity delivered would exceed the committed quantity. Are you sure you want to record this?')) {
          e.preventDefault()
          e.stopImmediatePropagation()
          qtyInput.value = '0'
          qtyInput.focus()
          setTimeout(() => {
            recordReceiptForm.querySelectorAll('[type=submit]').forEach((btn) => { btn.disabled = false })
          }, 0)
          return false
        }
      }
    })
  }

  // ************************************************************
  // Code to open person linkage modal in Person Role _form
  // ************************************************************
  let el = document.getElementById('pr-person-linkage-modal-open')
  if (el) {
    el.addEventListener('click', prOpenPersonLinkageModal)
  }

  function prResultCb (result) {
    if (result) {
      let personInputElem = document.getElementById("autocomplete-person")

      personInputElem.value = result.name
      personInputElem.disabled = true

      let personIdHidden = document.getElementById("person_role_person_id")
      personIdHidden.value = result.id

      let restricedNameContainer = document.getElementById("restriced-name-container")
      restricedNameContainer.style.display = "none"
    }
  }

  function prOpenPersonLinkageModal () {
    let params = {
      resultCb: prResultCb
    }

    ModalService.spawn('person-linkage-modal', params)
  }
  // *************************** END *********************************


  // ************************************************************
  // Code to open person linkage modal in User _form
  // ************************************************************

  let intv = setInterval(() => {
    let el = document.getElementById('user-person-linkage-modal-open')
    if (el) {
      el.addEventListener('click', userOpenPersonLinkageModal)
      clearInterval(intv)
    }
  }, 100)

  function userResultCb (result) {
    if (result) {
      let countryElem = document.getElementById("country-elem")
      countryElem.style.display = "none"

      let roleElem = document.getElementById("role-elem")
      roleElem.style.display = "none"

      let personElem = document.getElementById("person-select-elem")
      personElem.style.display = "block"

      let personInputElem = document.getElementById("person-input-elem")
      personInputElem.value = result.name
      personInputElem.disabled = true

      let personIdHidden = document.getElementById("hidden-person-id")
      personIdHidden.value = result.id

      let countrySelect = document.getElementById("country-select")
      countrySelect.value = result.country_id

      let createPersonElem = document.getElementById("create-person-radio-button")
      createPersonElem.checked = false
    }
  }

  function userOpenPersonLinkageModal () {
    let params = {
      resultCb: userResultCb
    }

    ModalService.spawn('person-linkage-modal', params)
  }

  setTimeout(() => {
    let createPersonRadioButton = document.getElementById("create-person-radio-button")
    createPersonRadioButton && createPersonRadioButton.addEventListener("click", function () {
      if (createPersonRadioButton.checked) {
        console.log("clicked")

        let countryElem = document.getElementById("country-elem")
        countryElem.style.display = "block"

        let roleElem = document.getElementById("role-elem")
        roleElem.style.display = "block"

        // reset all person attachments that couldve been made by
        // selecting existing person
        let personElem = document.getElementById("person-select-elem")
        personElem.style.display = "none"
        let personIdHidden = document.getElementById("hidden-person-id")
        personIdHidden.value = null
        let countrySelect = document.getElementById("country-select")
        countrySelect.value = null
        let roleSelect = document.getElementById("role-select")
        roleSelect.value = null
      }
    })
  }, 100)
  // *************************** END *********************************

  let flatpickrConfig = {
    maxDate: "today",
    allowInput: true,
    onOpen: function(selectedDates, dateStr, instance) {
        console.log(instance.input)
        instance.input.readOnly=true;
    },
    onClose: function(selectedDates, dateStr, instance) {
      instance.input.readOnly = false
      instance.input.blur();
    }
  }
  flatpickr('.datepicker', flatpickrConfig)
  Object.assign(flatpickrConfig, { enableTime: true, defaultHour: 0 })
  flatpickr('.datetimepicker', flatpickrConfig)
  tippy('[data-tippy-content]')

  const COMPONENT_MAP = {
    OpenModalButton,
    TargetAreaKestrel,
    SurveyBatchKestrel,
  }
  const toInstantiate = document.querySelectorAll('[data-vue-component]')
  if (toInstantiate.length > 0) {
    toInstantiate.forEach(el => {
      return createApp(COMPONENT_MAP[el.attributes['data-vue-component'].value]).mount(el)
    })
  }

  // Make components globally available
  window.FindMissingRelatableButton = FindMissingRelatableButton
  
  const hasQSDashboard = document.getElementById('qs_dashboard')
  if (hasQSDashboard) {
    window.qsEmbedding = QuickSightEmbedding
  }
  const lightBox = GLightbox({
    beforeSlideLoad: (slide, data) => {
      console.log('beforeSlideLoad', slide, data)
      return
    }
  })

  field_rep_forms()
  issues()
  tot_expense_reports()

  let staticMapImg = document.querySelector('.google-maps-static-image-modal-target')
  if (staticMapImg) {
    const elems = document.querySelectorAll('.interactive-map-container')
    let data = window.gon.interactive_map_data

    let kestrelEnabled = (data[0].kestrel_api_key && data[0].kestrel_api_url) || (data[0].target_areas_enabled) ? true : false

    staticMapImg.addEventListener('click', () => {
      // Check if target areas are enabled for this training center
      if (data[0] && data[0].target_areas_enabled) {
        // Navigate to the target area show page for the training center
        if (data[0].training_center_id) {
          window.location.href = `/training_centers/${data[0].training_center_id}/target_area`
        }
      } else {
        // alert('Target areas are not enabled for this country.')
        ModalService.spawn('interactive-map-modal', { data, kestrelEnabled })
      }
    })
  }


  // *************************************** View-only TargetArea modal on TCG show *****************************
  let openTargetAreaModalButtons = document.querySelectorAll('.target-area-modal-btn')
  if (openTargetAreaModalButtons.length > 0) {
    let allData = window.gon.target_areas_data

    openTargetAreaModalButtons.forEach(button => {
      const trainingCenterId = parseInt(button.dataset.trainingCenterId)
      const trainingCenterData = allData.find(tc => tc.id === trainingCenterId)
      
      if (trainingCenterData && trainingCenterData.target_areas_enabled) {
        let kestrelEnabled = trainingCenterData.kestrel_api_key && trainingCenterData.kestrel_api_url ? true : false

        button.addEventListener('click', () => {
          ModalService.spawn('target-area-modal', { 
            data: [trainingCenterData], 
            kestrelEnabled 
          })
        })
      }
    })
  }
  // *************************************** End View-only TargetArea modal on TCG show *************************


  // *************************************** SurveyBatch (show / edit / new) ***************************************
  const batchV2El = document.getElementById('batch-v2-container')
  if (batchV2El) {
    const batchV2Data = JSON.parse(batchV2El.dataset.batchV2Data)
    createApp(SurveyBatch, { batchData: batchV2Data }).mount(batchV2El)
  }
  // *************************************** END SurveyBatch *********************************************


  // *************************************** Kestrel Static Map ***************************************
  let staticKestrelMap = document.querySelector('.static-kestrel-map')
  if (staticKestrelMap) {
    let data = window.gon.interactive_map_data

    const props = {
      staticKestrelMapData: data,
    }

    const staticKestrelMapApp = createApp(StaticKestrelMap, props)
    staticKestrelMapApp.use(TurbolinksAdapter)
    staticKestrelMapApp.config.globalProperties.$rollbar = window.Rollbar
    staticKestrelMapApp.config.errorHandler = (err, vm, info) => {
      window.Rollbar.error(err, info)
      throw err
    }

    staticKestrelMapApp.mount('#static-kestrel-map')
  }
  // *************************************** END Kestrel Static Map ***************************************


  // *************************************** Target Area Component on Training Center Page ***************************************
  let targetAreaContainer = document.querySelector('#target-area-container')
  if (targetAreaContainer) {
    const props = {
      target_area_data: window.gon.target_area_data,
    }

    const targetAreaApp = createApp(TargetArea, props)
    targetAreaApp.use(TurbolinksAdapter)
    targetAreaApp.config.globalProperties.$rollbar = window.Rollbar
    targetAreaApp.config.errorHandler = (err, vm, info) => {
      window.Rollbar.error(err, info)
      throw err
    }

    targetAreaApp.mount(targetAreaContainer)
  }
  // *************************************** END Target Area on Training Center Page ***************************************

  // *************************************** Target Area V2 (Kestrel Vue) on Training Center Page ***************************************
  let targetAreaV2Container = document.querySelector('#target-area-v2-container')
  if (targetAreaV2Container) {
    const props = {
      target_area_data: window.gon.target_area_data,
    }

    const targetAreaV2App = createApp(TargetAreaKestrelV2, props)
    targetAreaV2App.use(TurbolinksAdapter)
    targetAreaV2App.config.globalProperties.$rollbar = window.Rollbar
    targetAreaV2App.config.errorHandler = (err, vm, info) => {
      window.Rollbar.error(err, info)
      throw err
    }

    targetAreaV2App.mount(targetAreaV2Container)
  }
  // *************************************** END Target Area V2 on Training Center Page ***************************************

  // *************************************** Target Areas on Training Center Group and Country ACHIEVE pages ***************************************
  let targetAreasContainer = document.querySelector('#target-areas-container')
  if (targetAreasContainer) {
    const props = {
      targetAreasData: window.gon.target_areas_data || [],
      apiData: window.gon.api_data || {},
    }

    const targetAreasApp = createApp(TargetAreas, props)
    targetAreasApp.use(TurbolinksAdapter)
    targetAreasApp.config.globalProperties.$rollbar = window.Rollbar
    targetAreasApp.config.errorHandler = (err, vm, info) => {
      window.Rollbar.error(err, info)
      throw err
    }

    targetAreasApp.mount(targetAreasContainer)
  }
  // *************************************** END Target Areas on Training Center Group and Country ACHIEVE pages ***********************************
  
  // *************************************** Achieve Dashboard Stats ***************************************
  let achieveDashboardContainer = document.querySelector('#achieve-dashboard-stats-container')
  if (achieveDashboardContainer) {
    const props = {
      targetAreasData: window.gon.target_areas_data || [],
      churchPresenceStats: window.gon.church_presence_stats || {},
      targetAreasTableData: window.gon.target_areas_table_data || [],
      apiData: window.gon.api_data || {},
    }

    const achieveDashboardApp = createApp(AchieveDashboardStats, props)
    achieveDashboardApp.use(TurbolinksAdapter)
    achieveDashboardApp.config.globalProperties.$rollbar = window.Rollbar
    achieveDashboardApp.config.errorHandler = (err, vm, info) => {
      window.Rollbar.error(err, info)
      throw err
    }

    achieveDashboardApp.mount(achieveDashboardContainer)
  }
  // *************************************** END Achieve Dashboard Stats ***************************************

  // *************************************** MRD Validation Section ***************************************
  let mrdValidationContainer = document.querySelector('#mrd-validation-section')
  if (mrdValidationContainer) {
    const props = {
      trainingCenterReportUuid: mrdValidationContainer.dataset.trainingCenterReportUuid,
      trainingCenterId: parseInt(mrdValidationContainer.dataset.trainingCenterId),
    }

    const mrdValidationApp = createApp(MrdValidationSection, props)
    mrdValidationApp.use(TurbolinksAdapter)
    mrdValidationApp.config.globalProperties.$rollbar = window.Rollbar
    mrdValidationApp.config.errorHandler = (err, vm, info) => {
      window.Rollbar.error(err, info)
      throw err
    }


    mrdValidationApp.mount(mrdValidationContainer)
  }
  // *************************************** END MRD Validation Section ***************************************

  // *************************************** Resource Deployment Deploy Vue Component ***************************************
  const resourceDeploymentDeployContainer = document.getElementById('resource-deployment-deploy-vue-app')

  if (resourceDeploymentDeployContainer) {
    const deployData = window.gon.resource_deployment_deploy || {}
    const props = {
      resourceDeploymentId: deployData.resource_deployment_id,
      countryId: deployData.country_id,
      belongableType: deployData.belongable_type,
      belongableId: deployData.belongable_id,
      parentResourceDeploymentId: deployData.parent_resource_deployment_id,
      resourceId: deployData.resource_id,
      resourceDonationId: deployData.resource_donation_id,
      totalAllocatedQuantity: deployData.total_allocated_quantity,
      totalDeployedQuantity: deployData.total_deployed_quantity,
      reportingMilestones: deployData.reporting_milestones || [],
      trainingCenterStates: deployData.training_center_states || [],
    }
    const resourceDeploymentDeployApp = createApp(ResourceDeploymentDeploy, props)
    resourceDeploymentDeployApp.use(TurbolinksAdapter)
    resourceDeploymentDeployApp.config.globalProperties.$rollbar = window.Rollbar
    resourceDeploymentDeployApp.config.errorHandler = (err, vm, info) => {
      window.Rollbar.error(err, info)
      throw err
    }

    resourceDeploymentDeployApp.mount(resourceDeploymentDeployContainer)
  }
  // *************************************** END Resource Deployment Deploy Vue Component ***************************************

  // ************************************************************
  // Register PersonRoleCreationModal
  // ************************************************************
  document.querySelectorAll('.person-role-creation-modal').forEach(el => {
    let data = el.dataset.roleCreationType ? window.gon[el.dataset.roleCreationType] : window.gon.person_role_creation_data

    console.log('data!', data)

    el.addEventListener('click', () => {
      ModalService.spawn('person-role-creation-modal', data)
    })
  })
  // *************************** End of PersonRoleCreationModal **********************************

  document.querySelectorAll('.autocomplete-field').forEach(e =>{
    load_autocomplete(e)
  })

  const chartjsContainers = document.querySelectorAll('.chartjs-container')

  if(chartjsContainers.length > 0) {
    import('./application_parts/charts')
      .then(lib => {
        chartjsContainers.forEach(elem => lib.default(elem))
      })
  }

  if (window.location.href.includes('/users/')) {
    const elem = document.querySelector('#permissions-app')
    if (elem) {
      const permissionsApp = createApp(PermissionsApp)
      permissionsApp.config.globalProperties.$rollbar = window.Rollbar

      permissionsApp.config.errorHandler = (err, vm, info) => {
        window.Rollbar.error(err, info)
        throw err
      }

      permissionsApp.use(TurbolinksAdapter)

      permissionsApp.mount(elem)
    }
  }

  const els = document.querySelectorAll('.bulk-action-selector-container')
  if (els.length > 0) {
    els.forEach(el => {
      const props = {
        ...el.dataset
      }

      const bulkActionSelectorApp = createApp(BulkActionSelector, props)
      bulkActionSelectorApp.config.globalProperties.$rollbar = window.Rollbar

      bulkActionSelectorApp.config.errorHandler = (err, vm, info) => {
        window.Rollbar.error(err, info)
        throw err
      }

      bulkActionSelectorApp.use(TurbolinksAdapter)


      bulkActionSelectorApp.mount(el)
    })
  }

  document.querySelectorAll('.v-select').forEach(el => {
    let cData = window.gon.js_control_data[el.id]

    const props = {
      ...cData
    }

    const frVisitSearchableSelect = createApp(SearchableSelect, props)
    frVisitSearchableSelect.config.globalProperties.$rollbar = window.Rollbar

    frVisitSearchableSelect.config.errorHandler = (err, vm, info) => {
      window.Rollbar.error(err, info)
      throw err
    }

    frVisitSearchableSelect.use(TurbolinksAdapter)

    frVisitSearchableSelect.mount(el)
  })

  document.querySelectorAll('.silo-selector').forEach(el => {
    let cData = window.gon.silo_selector

    const props = {
      ...cData
    }

    const siloLocationSelectorApp = createApp(siloLocationSelector, props)
    siloLocationSelectorApp.config.globalProperties.$rollbar = window.Rollbar

    siloLocationSelectorApp.config.errorHandler = (err, vm, info) => {
      window.Rollbar.error(err, info)
      throw err
    }

    siloLocationSelectorApp.use(TurbolinksAdapter)

    siloLocationSelectorApp.mount(el)
  })

  // JS that alerts user if a timothy already has a church
  if (document.getElementById('church-form')){
    let generationEl = document.getElementById('generation-trigger')
    let timothyDropdown = document.getElementById('timothy-dropdown')
    let planterDropdown = document.getElementById('discipleship-planter-dropdown')
    let activeDropdown = timothyDropdown || planterDropdown
    let churchCreateButton = document.getElementById("church-create-button")

    // Legacy timothy dropdown: direct change triggers dupe check (no auto-generation set)
    if (timothyDropdown) {
      timothyDropdown.addEventListener('change', function (e) {
        let selectedOpt = e.target.options[e.target.selectedIndex]
        if (selectedOpt && selectedOpt.dataset.church) {
          checkForDupeChurch(JSON.parse(selectedOpt.dataset.church))
        }
      })
    }
    // listen for change of generation
    if (generationEl) {
      generationEl.addEventListener('change', function (e) {
        let newGen = e.target.value
        let churchData = null
        console.log(e)
        if (activeDropdown){
          let selectedOpt = activeDropdown.selectedIndex && activeDropdown.options[activeDropdown.selectedIndex]
          if (selectedOpt && selectedOpt.dataset.church) {
            console.log(selectedOpt)
            churchData = JSON.parse(selectedOpt.dataset.church)
          }
        } else if (gon.timothy_has_church) {
          // this handles when timothy is already populated
          churchData = gon.timothy_has_church
        }
        checkForDupeChurch(churchData)
      })
    }
    function checkForDupeChurch(churchData){
      console.log('checking for dupes')
      churchCreateButton.dataset.possibleDupes = null
      let churchGen = generationEl.value
      if (churchGen && churchData) {
        console.log(churchGen)
        console.log(churchData["has_church"])
        let type = churchGen == '1' ? 'church-1g' : 'church-2g'
        console.log(type)
        if ((churchGen == '1' && churchData['has_church'] == true) || ( churchGen != '1' && churchData['has_2g_church'])) {
          churchCreateButton.dataset.possibleDupes = 'true'
          console.log('need to spawn modal')
          console.log(churchData)
          // we need to popup warning
          ModalService.spawn('duplicate-visit-warning', { title: 'warning', type: type, previous_items: churchGen == '1' ? churchData.churches_1g : churchData.churches_2g })
        }
      }

    }

    if (churchCreateButton) {
      churchCreateButton.addEventListener("click", e => {
        if (e.target.dataset.possibleDupes === 'true') {
          if (!confirm(`This church record may be a duplicate. Are you sure you want to create an additional church record?`)) {
            e.preventDefault()
          }
        }
      })
    }

  }

  if (document.getElementById('interactive-google-maps')) {
    let data = window.gon.interactive_map_data

    const props = {
      interactiveMapData: data,
      apiKey: window.gon.googleMapsApiKey,
    }

    const interactiveMapApp = createApp(InteractiveGoogleMaps, props)

    interactiveMapApp.component('GoogleMap', GoogleMap)
    interactiveMapApp.component('Marker', Marker)
    interactiveMapApp.component('InfoWindow', InfoWindow)
    interactiveMapApp.component('MarkerCluster', MarkerCluster)

    interactiveMapApp.use(TurbolinksAdapter)

    interactiveMapApp.config.globalProperties.$rollbar = window.Rollbar

    interactiveMapApp.config.errorHandler = (err, vm, info) => {
      window.Rollbar.error(err, info)
      throw err
    }

    interactiveMapApp.mount('#interactive-google-maps')
  }

  // ******************** Standardized Location Selector ******************** 
  if (document.getElementById('standardized-location-selector')) {
    const elems = document.querySelectorAll('.location-container')
    let data = JSON.parse(elems[0].dataset.pointData)

    console.log('data!!!', data)

    const props = {
      pointData: data
    }

    const standardizedLocationVueApp = createApp(StandardizedLocation, props)
    standardizedLocationVueApp.config.globalProperties.$rollbar = window.Rollbar

    standardizedLocationVueApp.config.errorHandler = (err, vm, info) => {
      window.Rollbar.error(err, info)
      throw err
    }

    standardizedLocationVueApp.use(TurbolinksAdapter)
    standardizedLocationVueApp.mount('#standardized-location-selector')
  }
  // ******************** End of Standardized Location Selector ********************

  const directUploadEls = document.querySelectorAll('.direct-upload-target')
  if (directUploadEls.length > 0) {
    directUploadEls.forEach(el => {
      const handler = new DirectUploadHandler(el)
    })
  }

  const spinCatcherEls = document.querySelectorAll('.tcr-spin-catcher')
  if (spinCatcherEls.length > 0) {
    spinCatcherEls.forEach(el => {
      el.addEventListener('click', (ev) => {
        let target = ev.target
        const placeholder = target.getAttribute('placeholder')
        let phVal = parseInt(placeholder)
        let val = target.value == '' ? 0 : parseInt(target.value)
        if (placeholder != '') {
          target.value = val + phVal
          target.setAttribute('placeholder', '')
        }
      })
    })
  }

  const communicationEntity = document.getElementById('communication-entity')
  const hiddenCommEntityId = document.getElementById('communication-entity-id-hidden')
  if (communicationEntity) {
    communicationEntity.addEventListener('click', function (event) {
      hiddenCommEntityId.value = event.target.value
    })
  }

  const belongableSelect = document.getElementById('belongable-dropdown')
  const belongableHiddenEl = document.getElementById('belongable-hidden')
  if (belongableSelect) {
    belongableSelect.addEventListener('change', function (event) {
      belongableHiddenEl.value = event.target.value
    })
  }

  const countrySelect = document.getElementById('country-dropdown')
  const countryHiddenEl = document.getElementById('country-id-hidden')
  if (countrySelect) {
    countrySelect.addEventListener('change', function (event) {
      countryHiddenEl.value = event.target.value
    })
  }

  const churchStatusEl = document.getElementById('church_state')
  const churchUnderReviewEl = document.getElementById('church-review')

  function setChurchStatefulFieldsVisibility() {
    const selected = churchStatusEl.options[churchStatusEl.selectedIndex].value
    const resonTextArea = document.getElementById('reason-review-text')

    if (selected === "under_review") {
      churchUnderReviewEl.style.display = "block"
    } else {
      churchUnderReviewEl.style.display = "none"
      resonTextArea.value = ''
    }
  }

  if (churchStatusEl) {
    churchUnderReviewEl.style.display = "none"

    setChurchStatefulFieldsVisibility(churchStatusEl, churchUnderReviewEl)

    churchStatusEl.addEventListener('change', function () {
      setChurchStatefulFieldsVisibility(churchStatusEl, churchUnderReviewEl)
    })
  }

  // passes data to modal in params.data object
  const modalElems = document.querySelectorAll('.modal-trigger')
  if (window.gon.modal_data) {
    for (let row of modalElems) {
      let data = window.gon.modal_data[row.id]
      if (data) {
        row.addEventListener('click', () => {
          ModalService.spawn(data.modal_name, { data })
        })
      }
    }
  }

  // passes data to modal directly in params
  const mElems = document.querySelectorAll('.modal-trigger-direct')

  for (let row of mElems) {
    let data = window.gon.modal_data[row.id]
    if (data) {
      row.addEventListener('click', () => {
        ModalService.spawn(data.modal_name, { ...data })
      })
    }
  }

  // Record info modal trigger (show pages)
  const recordInfoTriggers = document.querySelectorAll('.record-info-trigger')
  for (const el of recordInfoTriggers) {
    el.addEventListener('click', () => {
      try {
        const recordInfo = JSON.parse(el.dataset.recordInfo || '{}')
        ModalService.spawn('RecordInfoModal', { data: recordInfo })
      } catch (e) {
        console.warn('Record info modal: invalid data', e)
      }
    })
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        el.click()
      }
    })
  }

  const datePickerEl = document.getElementById('deployed-datepicker')
  if (datePickerEl) {
    datePickerEl.addEventListener('change', (e) => {
      const datePickerHiddenEls = document.querySelectorAll('.datepicker-hidden')

      for (let el of datePickerHiddenEls) {
        el.value = e.target.value
      }
    })
  }

  let triggerBulkAction = document.getElementById('bulk-action-trigger')
  if (triggerBulkAction) {
    triggerBulkAction.addEventListener('click', () => {
      let ds = triggerBulkAction.dataset
      let baOpts = {
        bulkAction: ds.bulkAction,
        bulkActionModel: ds.bulkActionModel,
        bulkActionFilter: ds.bulkActionFilter,
        bulkActionOpts: ds.bulkActionOpts ? JSON.parse(ds.bulkActionOpts) : {},
        ids: ds.ids ? JSON.parse(ds.ids) : null,
      }
      baOpts['bulkActionOpts']['modalType'] = baOpts['bulkActionOpts']['modalType'] || null
      ModalService.spawn('bulk-action-modal', baOpts)
    })
  }

  let selected = document.getElementsByName('selected[]')
  if (selected) {
    let submit = document.getElementById('submit-button')
    let date = document.getElementById('deployed-datepicker')
    let ids = []
    let instructions = document.getElementById('instructions')
    let quantBoxes = document.getElementsByClassName('quantBoxes')
    let checked = []

    for (let el of selected) {
      el.addEventListener('change', evt => {
        checked = Array.from(selected).filter(el => el.checked == true)
        if (el.dataset.bulkActionModel === "ResourceDeployment") {
          if (checked.length != 0) {
            submit.value = 'Update Deployment Date'
            instructions.innerHTML = 'Select a new deployment date below then select resources using the check boxes on the left and click on "Update Deployment Date"'
            for (let box of quantBoxes) {
              box.disabled = true
              box.value = ''
            }
          } else {
            submit.value = 'Deploy Resources'
            instructions.innerHTML = 'Select the date the resource was deployed below then fill out a quantity for each training center and click on "Deploy Resources"'
            for (let box of quantBoxes) {
              box.disabled = false
            }
          }
        }
      })
    }

    if (submit) {
      submit.addEventListener('click', evt => {
        if (checked.length != 0) {
          if (date.value != '') {
            for (let el of selected) {
              if (el.checked) {
                const localIds = el.value.split(',').map(x => parseInt(x))
                localIds.forEach(x => ids.push(x))
              }
            }

            BulkActionService.changeDeployDate(ids, "ResourceDeployment", date.value)
          } else {
            FlashMessages.error("Please select a deployment date")
            evt.preventDefault()
          }
        }
      })
    }
  }

  // BELOW IS FOR AUTOMATIC TRANSLATION on Form Responses
  let translateButton = document.getElementById("translate-button")
  if (translateButton) {
    translateButton.addEventListener("click", function () {
      let originalFields = document.getElementsByClassName("original-field")
      let fieldsToTranslate = document.getElementsByClassName("translated-field")

      for (let field of originalFields) {
        field.classList.toggle("hidden")
      }

      for (let field of fieldsToTranslate) {
        field.classList.toggle("hidden")
      }
    })
  }
  // add trigger for issue settings modal
  let issueSettingsEl = document.getElementById('issue-settings')
  if (issueSettingsEl) {
    console.log('adding event listener to Issue-Settings button')
    issueSettingsEl.addEventListener('click', () => {
      console.log('fired!!')
      ModalService.spawn('issue-settings-modal', { })
    })
  }
  // set number of seconds before timeout to start polling server
  let pollStart = 10
  function pollForTimeout() {
    axios.get('/ttl').then(resp => {
      console.log(resp.data)
      if (resp.status === 200 && (resp.data <= 0)) {
        alert('Your Session has Timed Out')
        window.location.href = '/timeout';
      } else if (resp.data > pollStart) {
        // session timer probably got reset by ajax request
        setTimeout(pollForTimeout, (resp.data - pollStart) * 1000)
      } else {
        setTimeout(pollForTimeout, 1000)
      }
    })
  }
  // set polling to start before session timeout
  let timeoutIn = gon.devise_timeout - pollStart
  if (window.location.pathname != '/users/sign_in') {
    setTimeout(pollForTimeout, timeoutIn * 1000)
  } else {
    //when on login page, force refresh every hour to keep csrf token alive
    setTimeout(() => {
      window.location.reload()
    }, 1000 * 60 * 60)
  }

  // Initialize Find Relatable buttons for Timothy/Titus roles without relatables
  // These must be unmounted before Turbo navigates away to avoid "nextSibling of null" errors
  const findRelatableButtons = document.querySelectorAll('[id^="find-relatable-button-"]')
  const findRelatableApps = []
  findRelatableButtons.forEach(buttonElement => {
    const personRoleId = buttonElement.id.replace('find-relatable-button-', '')
    
    // Extract person role data from data attributes
    const personRoleData = {
      id: parseInt(personRoleId),
      person_name: buttonElement.dataset.personName || 'Unknown Person',
      role: buttonElement.dataset.role || 'unknown',
      country_id: buttonElement.dataset.countryId ? parseInt(buttonElement.dataset.countryId) : null,
      country_name: buttonElement.dataset.countryName || ''
    }

    const app = createApp({
      template: `
        <FindMissingRelatableButton 
          :person-role="personRole"
          :on-result="handleResults"
        />
      `,
      data() {
        return {
          personRole: personRoleData
        }
      },
      methods: {
        handleResults(selectedRelatables) {
          console.log('Selected relatables for person role', personRoleId, ':', selectedRelatables)
          // You can customize this to handle the selected results
          // For example, update the person role's relatable or show a confirmation
          if (selectedRelatables.length > 0) {
            alert(`Selected ${selectedRelatables.length} relatable(s) for processing. Check console for details.`)
            // Optionally reload the page to show updated relatable
            // window.location.reload()
          }
        }
      }
    })
    
    app.component('FindMissingRelatableButton', window.FindMissingRelatableButton)
    app.mount(buttonElement)
    findRelatableApps.push(app)
  })

  // Unmount Find Relatable apps before Turbo replaces the page to prevent Vue DOM errors
  if (findRelatableApps.length > 0) {
    const unmountFindRelatableApps = () => {
      findRelatableApps.forEach(app => {
        try {
          app.unmount()
        } catch (_e) {
          // App may already be unmounted if DOM was replaced
        }
      })
      document.removeEventListener('turbo:visit', unmountFindRelatableApps)
    }
    document.addEventListener('turbo:visit', unmountFindRelatableApps)
  }

})


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
